<wavelength-ui-shell [title]="title"
                     [subtitle]="subtitle"
                     [logo]="logo"
                     [home]="home"
                     [items]="items"
                     [toolbarItems]="toolbarItems"
                     (initialize)="onInitialized()">
  <ng-container customHeader>
      <div class="menu">
        <button [matMenuTriggerFor]="menu"
                class="shell-button user-account">
          <div class="user-name">{{ account?.username }}</div>
          <div class="user-icon"
               [matTooltip]="account?.username">
            <div class="icon-container"><i class="icon icon-ic_fluent_person_20_regular"></i></div>
          </div>
        </button>
        <mat-menu #menu="matMenu"
                  class="options-menu">
          <button mat-menu-item
                  (click)="onLogoutClicked()"><i class="icon icon-ic_fluent_sign_out_20_regular"></i>
            <span>Sign out</span>
          </button>
        </mat-menu>
      </div>
  </ng-container>
</wavelength-ui-shell>
